<template>
  <div class="iframeBox">
    <iframe
      src="http://192.168.2.3:7860/?__theme=dark"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframeUrl: '',
    };
  },
  created() {
    console.log(123213)
  }
};
</script>

<style lang="scss" scoped>
.iframeBox {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>
